{
  "name": "easytrack-admin",
  "version": "2.17.0-SNAPSHOT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c local -o",
    "start:test": "ng serve -c test-env",
    "azure-test-start": "ng serve --configuration=azure-test -o",
    "azure-start": "ng serve --configuration=azure -o",
    "build": "ng build",
    "test": "ng test --coverage",
    "test:watch": "ng test --watch",
    "lint": "ng lint",
    "build-install:lib": "cd ../bs-components && npm run build-pack:local && cd - && npm run install:lib",
    "install:lib": "npm install ../bs-components/dist/bs-components/bs-components-1.0.1-dev.tgz",
    "e2e:open": "playwright test --ui",
    "e2e:run": "playwright test",
    "icons:install": "npm install --save '@awesome.me/kit-dfbfaeb168@latest'",
    "icons:update": "npm update '@awesome.me/kit-dfbfaeb168'"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.0",
    "@angular/cdk": "^22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/material": "^22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@awesome.me/kit-dfbfaeb168": "^1.0.14",
    "@fortawesome/fontawesome-free": "^7.3.1",
    "@grafana/faro-web-sdk": "^2.12.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "bootstrap": "^5.3.8",
    "bs-components": "1.8.26",
    "date-fns": "^4.4.0",
    "event-source-polyfill": "^1.0.31",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.8",
    "jszip": "^3.10.2",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.4",
    "lodash": "^4.18.1",
    "ngx-extended-pdf-viewer": "^30.0.1",
    "ngx-spinner": "^22.0.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/schematics": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@bgotink/playwright-coverage": "^0.3.2",
    "@playwright/test": "^1.63.0",
    "@types/bootstrap": "^5.2.11",
    "@types/event-source-polyfill": "^1.0.5",
    "@types/lodash": "^4.17.25",
    "@types/node": "^25.9.8",
    "@typescript-eslint/eslint-plugin": "^8.59.4",
    "@typescript-eslint/parser": "^8.58.4",
    "@vitest/coverage-v8": "^4.1.11",
    "dotenv": "^18.0.1",
    "eslint": "^10.11.0",
    "jsdom": "^30.1.2",
    "typescript": "~6.0.3",
    "vitest": "^4.1.11",
    "webpack": "^5.111.1"
  },
  "browserslist": [
    "> 0.5%",
    "last 2 versions",
    "Firefox ESR",
    "not dead",
    "not IE 9-11"
  ],
  "allowScripts": {
    "core-js@3.49.0": true,
    "esbuild@0.28.2": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "@parcel/watcher@2.6.0": true,
    "unrs-resolver@1.12.2": true
  }
}
